<template>
  <div class="-mx-3">
    <h3 class="text-secondary text-2xl font-bold ml-3 mb-4">{{$t('star_carousel.title')}}</h3>
    <carousel
      :itemsToShow="itemsToShow"
      :itemsToScroll="1"
      snapAlign="start"
    >
      <slide v-for="star in stars" :key="star.id">
        <StarItem :star="star" />
      </slide>

      <template #addons>
        <navigation />
      </template>
    </carousel>
  </div>
</template>

<script>
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide, Navigation } from "vue3-carousel";
import StarItem from "@/components/UI/Stars/StarItem";
import { vueWindowSizeMixin } from 'vue-window-size/mixin';
export default {
  name: "StarCarousel",
  mixins: [vueWindowSizeMixin()],
  data() {
    return {
      itemsToShow: 4,
    };
  },
  mounted() {
    this.calculateItemsToShow();
  },
  components: {
    Carousel,
    Slide,
    Navigation,
    StarItem,
  },
  props: {
    stars: {
      type: Array,
      required: true,
    },
  },
  watch: {
    $windowWidth() {
      this.calculateItemsToShow();
    },
  },
  methods: {
    calculateItemsToShow() {
      if (this.$windowWidth < 768) {
        this.itemsToShow = 1;
      } else if (this.$windowWidth < 1280) {
        this.itemsToShow = 2;
      } else {
        this.itemsToShow = 4;
      }
    },
  },
};
</script>

<style>
</style>